module.exports = __webpack_public_path__ + "static/img/14baohuhaiyang.aa02117e.gif";